var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDribbble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6738 7.13721C13.9764 6.02519 15.8801 4.68201 17.2093 3.4623C15.6921 2.53464 13.9085 2 12 2C10.5348 2 9.14316 2.31512 7.88922 2.88128C8.7755 3.92278 9.97225 5.46687 11.2337 7.34466C11.3818 7.27657 11.5285 7.20739 11.6738 7.13721Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82625 7.94086C8.5562 6.07099 7.37027 4.56676 6.54428 3.61792C4.48744 4.95941 2.95484 7.03748 2.32074 9.47784C4.9821 9.42975 7.53537 8.83011 9.82625 7.94086Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.67 9.22021C11.023 9.77166 11.3778 10.3473 11.7288 10.9431C12.1821 11.7128 12.6276 12.514 13.0538 13.3384C12.1893 13.6478 11.3669 14.0026 10.5974 14.394C8.75111 15.3334 7.18287 16.4975 6.06678 17.7814C5.67419 18.233 5.33233 18.7059 5.05433 19.1943C3.17114 17.3758 2 14.8247 2 12C2 11.656 2.01737 11.3161 2.05128 10.981C5.14497 10.9697 8.08636 10.2596 10.67 9.22021Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5019 12.8748C14.0256 11.9411 13.5265 11.0398 13.0212 10.1819C12.7034 9.64231 12.3825 9.11868 12.0622 8.61372C12.1507 8.57214 12.2387 8.53022 12.3262 8.48798C14.8412 7.27333 16.9665 5.76684 18.4488 4.35693C20.6207 6.19129 22 8.93459 22 12L21.9999 12.0337C19.3867 11.8861 16.8259 12.2156 14.5019 12.8748Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.725 14.6921C12.8606 14.9932 12.0406 15.3428 11.2776 15.731C9.56136 16.6041 8.16085 17.6588 7.19882 18.7655C6.78987 19.2359 6.46757 19.7067 6.23181 20.1697C7.86168 21.3226 9.85172 22 12 22C13.4429 22 14.8144 21.6944 16.0533 21.1444C15.5429 18.9597 14.7106 16.7691 13.725 14.6921Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.418 20.4065C16.8914 18.3017 16.0961 16.2166 15.1728 14.2454C17.2641 13.6807 19.5531 13.4016 21.8838 13.5296C21.4414 16.4118 19.7683 18.8886 17.418 20.4065Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDribbble);
export default __webpack_public_path__ + "static/media/dribbble.0f77aa9cc3f2041c85092ce753aada29.svg";
export { ForwardRef as ReactComponent };